import { Component, Input, OnInit, ChangeDetectionStrategy, Injectable, Inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';




@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css'],
})
export class NavMenuComponent {


  constructor(public _authservice: AuthService) {
  }

  isExpanded = false;

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
